import { Typography } from './Typography';
export { Typography };
export { TypographySecondary } from './TypographySecondary';
export default Typography;
//# sourceMappingURL=index.js.map